import React, { Fragment } from 'react';
import {
    Segment,
    Table,
    Header,
    Form,
    Button,
    Select,
    Input,
    Icon,
    Popup
} from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../util/css';
import { FormattedMessage } from 'react-intl';

export default class AddressForm extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            addresses: [],
            deletingRowId: null,
            saving: false,

            street: '',
            place: '',
            municipality: null,
            canton: null,
            entity: null,
            country: null,

            disabledMunicipality: false,
            disabledCanton: false,
            disabledEntity: false,

            streetError: false,
            placeError: false,
            municipalityError: false,
            cantonError: false,
            entityError: false,
            countryError: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMunicipalityChange = this.handleMunicipalityChange.bind(this);
        this.handleCantonChange = this.handleCantonChange.bind(this);
        this.handleEntityChange = this.handleEntityChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.onAddNewAddress = this.onAddNewAddress.bind(this);
        this.getAddresses = this.getAddresses.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    componentDidMount() {
        this.getAddresses();
    }

    getAddresses() {
        const { addresses } = this.props;
        this.setState({ addresses });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ addresses: nextProps.addresses });
    }

    onAddNewAddress() {
        const {
            street,
            place,
            municipality,
            canton,
            entity,
            country,
            disabledMunicipality,
            disabledCanton,
            disabledEntity,
        } = this.state;

        if (
            street === '' || street === null ||
            place === '' || place === null ||
            (municipality === null && !disabledMunicipality) ||
            (canton === null && !disabledCanton) ||
            (entity === null && !disabledEntity) ||
            country === null
        ) {
            this.setState({
                streetError: street === null || street === '',
                placeError: place === null || place === '',
                countryError: !country,
                municipalityError: municipality === null && !disabledMunicipality,
                cantonError: canton === null && !disabledCanton,
                entityError: entity === null && !disabledEntity,
            });
            return;
        }

        const address = {
            street,
            place,
            municipality: municipality ? { id: municipality } : null,
            canton: canton ? { id: canton } : null,
            entity: entity ? { id: entity } : null,
            country: country ? { id: country } : null,
        };

        this.setState({ saving: true }, () => {
            this.props.onAddNewAddress(address)
                .then(() => {
                    this.setState({ saving: false });
                    this.props.switchEditMode();
                    this.resetValues();
                })
                .catch(() => {
                    this.setState({ saving: false });
                });
        });
    }

    resetValues() {
        this.setState({
            street: '',
            place: '',
            municipality: null,
            canton: null,
            entity: null,
            country: null,
            disabledMunicipality: false,
            disabledCanton: false,
            disabledEntity: false,
            streetError: false,
            placeError: false,
            municipalityError: false,
            cantonError: false,
            entityError: false,
            countryError: false,
        });
    }

    handleInputChange(e, {
        name,
        value
    }) {
        this.setState({ [name]: value });
    }

    handleMunicipalityChange(e, { value }) {
        const municipality = this.props.municipalities.find(el => el.id === value);
        const canton = municipality.canton ? municipality.canton.id : null;
        const entity = municipality.entity ? municipality.entity.id : null;
        const country = municipality.country ? municipality.country.id : null;
        this.setState({
            municipality: value,
            canton,
            entity,
            country
        });
    }

    handleEntityChange(e, { value }) {
        let {
            canton,
            municipality,
            disabledMunicipality,
            disabledCanton
        } = this.state;

        canton = null;
        municipality = null;
        const country = this.props.countries.find(el => el.name === 'Bosna i Hercegovina');

        if (value === 3) {
            disabledCanton = true;
            disabledMunicipality = true;
        } else if (value === 2) {
            disabledCanton = true;
            disabledMunicipality = false;
        } else {
            disabledCanton = false;
            disabledMunicipality = false;
        }

        this.setState({
            entity: value,
            canton,
            municipality,
            country: country.id,
            disabledCanton,
            disabledMunicipality
        });
    }

    handleCantonChange(e, { value }) {
        const entity = this.props.entities.find(el => el.name === 'Federacija Bosne i Hercegovine');
        const country = this.props.countries.find(el => el.name === 'Bosna i Hercegovina');
        this.setState({
            canton: value,
            municipality: null,
            entity: entity.id,
            country: country.id
        });
    }

    handleCountryChange(e, { value }) {
        const isBiH = value === 22;
        this.setState({
            country: value,
            disabledEntity: !isBiH,
            disabledCanton: !isBiH,
            disabledMunicipality: !isBiH,
            municipality: null,
            entity: null,
            canton: null,
        });
    }

    displayPlaceProperly(place) {
        return ['name', 'municipality', 'canton', 'entity', 'country']
            .map(key => place[key] && (typeof place[key] === 'string' ? place[key] : place[key].name))
            .filter(Boolean)
            .join(', ');
    }

    handleDeleteClick(id) {
        this.setState({ deletingRowId: id });
    }

    handleCancelClick() {
        this.setState({ deletingRowId: null });
    }

    handleConfirmClick() {
        const { deletingRowId } = this.state;
        this.setState({ saving: true }, () => {
            this.props.onDeleteAddress(deletingRowId)
                .then(() => {
                    this.setState({
                        deletingRowId: null,
                        saving: false
                    });
                })
                .catch(() => {
                    this.setState({ saving: false });
                });
        });
    }

    render() {
        const {
            addresses,
            deletingRowId,
            saving
        } = this.state;
        const {
            editMode,
            onClose,
            switchEditMode
        } = this.props;

        return (
            <Fragment>
                {/*!!addresses.length &&*/ (
                    <Segment clearing>
                        <Header style={IconHeader} floated="right">
                            <Popup
                                trigger={
                                    <Icon
                                        link
                                        size="mini"
                                        circular
                                        name="close"
                                        onClick={onClose}
                                        style={FiltersOnStyle}
                                    />
                                }
                                content="Zatvori"
                                hideOnScroll
                                position="top center"
                            />
                        </Header>
                        <Table compact size="small" celled verticalAlign={'middle'}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                    <Table.HeaderCell>Ulica</Table.HeaderCell>
                                    <Table.HeaderCell>Mjesto</Table.HeaderCell>
                                    <Table.HeaderCell textAlign={'center'} width={1}>
                                        {
                                            <Popup
                                                content={<FormattedMessage id="externalStudent.add"/>}
                                                position="top center"
                                                trigger={<Button
                                                    basic
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="blue"
                                                    disabled={editMode || !!deletingRowId}
                                                    onClick={switchEditMode}
                                                >
                                                    <Icon name="plus"/>
                                                </Button>}/>
                                        }
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {addresses.map((el, index) => (
                                    <Table.Row key={el.id}>
                                        <Table.Cell width={1}>{index + 1}.</Table.Cell>
                                        <Table.Cell>{el.street}</Table.Cell>
                                        <Table.Cell>{this.displayPlaceProperly(el.place)}</Table.Cell>
                                        <Table.Cell textAlign={'center'} width={1}>
                                            {deletingRowId === el.id
                                                ?
                                                <Fragment>
                                                    <Popup
                                                        content="Potvrdi"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                circular
                                                                icon
                                                                size="tiny"
                                                                color="blue"
                                                                onClick={this.handleConfirmClick}
                                                                disabled={saving}
                                                                loading={saving}
                                                            >
                                                                <Icon name="check"/>
                                                            </Button>
                                                        }
                                                    />
                                                    <Popup
                                                        content="Otkaži"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                circular
                                                                icon
                                                                size="tiny"
                                                                color="blue"
                                                                onClick={this.handleCancelClick}
                                                                disabled={saving}
                                                            >
                                                                <Icon name="close"/>
                                                            </Button>
                                                        }
                                                    />
                                                </Fragment>
                                                :
                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={editMode || (deletingRowId && deletingRowId !== el.id)}
                                                            basic="true"
                                                            circular
                                                            icon="trash alternate"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => {
                                                                this.handleDeleteClick(el.id);
                                                            }}
                                                        />
                                                    }
                                                />
                                            }
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Segment>
                )}

                {editMode && (
                    <Segment secondary clearing>
                        <Header as="h5">Dodaj novu adresu</Header>
                        <Form noValidate>
                            <Form.Group widths="3">
                                <Form.Field
                                    control={Input}
                                    onChange={this.handleInputChange}
                                    placeholder="Ulica"
                                    value={this.state.street}
                                    name="street"
                                    required
                                    error={this.state.streetError}
                                />
                                <Form.Field
                                    control={Input}
                                    onChange={this.handleInputChange}
                                    placeholder="Mjesto"
                                    value={this.state.place}
                                    name="place"
                                    required
                                    error={this.state.placeError}
                                />
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleMunicipalityChange}
                                    placeholder="Opština"
                                    value={this.state.municipality}
                                    options={this.props.municipalities}
                                    name="municipality"
                                    search
                                    disabled={this.state.disabledMunicipality}
                                    required={!this.state.disabledMunicipality}
                                    error={this.state.municipalityError}
                                />
                            </Form.Group>
                            <Form.Group widths="3">
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleCantonChange}
                                    placeholder="Kanton"
                                    value={this.state.canton}
                                    options={this.props.cantons}
                                    name="canton"
                                    search
                                    disabled={this.state.disabledCanton}
                                    required={!this.state.disabledCanton}
                                    error={this.state.cantonError}
                                />
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleEntityChange}
                                    placeholder="Entitet"
                                    value={this.state.entity}
                                    options={this.props.entities}
                                    name="entity"
                                    search
                                    disabled={this.state.disabledEntity}
                                    required={!this.state.disabledEntity}
                                    error={this.state.entityError}
                                />
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleCountryChange}
                                    placeholder="Država"
                                    value={this.state.country}
                                    options={this.props.countries}
                                    name="country"
                                    search
                                    required
                                    error={this.state.countryError}
                                />
                            </Form.Group>
                            <Button basic color={'blue'} floated="right" onClick={switchEditMode} disabled={saving}>
                                Odustani
                            </Button>
                            <Button color={'blue'} floated="right" loading={saving} disabled={saving}
                                    onClick={this.onAddNewAddress}>
                                Sačuvaj
                            </Button>
                        </Form>
                    </Segment>
                )}
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderAddressForm.js